import React from 'react';
import HeaderWalletConnect from './HeaderWalletConnect';

const WalletTest = () => {
  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Wallet Connection Test</h1>
      
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Test the Connect Wallet Button</h2>
        <p className="text-gray-600 mb-6">
          This is a test page to verify that the wallet connection functionality is working properly.
          Try clicking the connect wallet button below:
        </p>
        
        <div className="flex justify-center mb-8">
          <HeaderWalletConnect />
        </div>
        
        <div className="mt-8 p-4 bg-gray-50 rounded-lg">
          <h3 className="font-semibold mb-2">What to test:</h3>
          <ul className="list-disc list-inside text-gray-600 space-y-1">
            <li>Click "Connect Wallet" button in the header</li>
            <li>MetaMask should prompt for connection</li>
            <li>After connection, button should show wallet address</li>
            <li>Click on connected button to see wallet details dropdown</li>
            <li>Test disconnect functionality</li>
            <li>Verify wallet balance and network information is displayed</li>
          </ul>
        </div>
        
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <h3 className="font-semibold mb-2">Expected Behavior:</h3>
          <ul className="list-disc list-inside text-gray-600 space-y-1">
            <li>Button should show "Connect Wallet" when not connected</li>
            <li>Button should show truncated wallet address when connected</li>
            <li>Clicking connected button should show dropdown with wallet details</li>
            <li>Dropdown should display: Address, Balance, Network, and Complete Application button</li>
            <li>Disconnect should clear all wallet information</li>
          </ul>
        </div>
        
        <div className="mt-6 p-4 bg-yellow-50 rounded-lg">
          <h3 className="font-semibold mb-2">Troubleshooting:</h3>
          <ul className="list-disc list-inside text-gray-600 space-y-1">
            <li>Make sure MetaMask is installed in your browser</li>
            <li>Check browser console for any JavaScript errors</li>
            <li>Ensure you're on a supported network (Ethereum mainnet, testnets)</li>
            <li>Try refreshing the page if connection fails</li>
            <li>Check if the ethers library is properly loaded</li>
          </ul>
        </div>
        
        <div className="mt-6 p-4 bg-green-50 rounded-lg">
          <h3 className="font-semibold mb-2">Success Indicators:</h3>
          <ul className="list-disc list-inside text-gray-600 space-y-1">
            <li>Wallet connects without errors</li>
            <li>Wallet address is displayed correctly</li>
            <li>Balance shows actual ETH amount</li>
            <li>Network information is accurate</li>
            <li>Disconnect functionality works</li>
            <li>No console errors during connection/disconnection</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WalletTest;
